/*
  Shrine: opens and closes the "+ Delivery instructions" box in the basket (drawer and page).
  Markup: snippets/shrine-cart-note.liquid. Saving the note is still theme.js (it listens to the textarea itself).
  One listener on the document, so it keeps working when the drawer is redrawn.
*/
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-shrine-note-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    var sign = btn.querySelector('[data-shrine-note-sign]');
    if (sign) sign.textContent = open ? '\u2212' : '+';
    if (open) {
      var ta = panel.querySelector('textarea');
      if (ta) ta.focus();
    }
  });
})();
